// extracted by css-extract-rspack-plugin
export default {"cls1":"LoggedOutDiscoveryPage-cls1_IRY","cls2":"LoggedOutDiscoveryPage-cls2_VIs LoggedOutDiscoveryPage-cls1_IRY"};